<template>
  <div>
    <router-link :to="current.url">
      <div
        v-if="current.is_show !== 0"
        class="level_one_item view-flex view-flex-middle"
        :class="{ 'is-active': isActive }"
      >
        <div class="iconfont icon-xitongshouye2" />
        {{ current.name }}
      </div>
    </router-link>
    <SplitLine v-if="current.is_show !== 0 && !isLast" />
  </div>
</template>

<script>
import SplitLine from './splitLine'
export default {
  components: {
    SplitLine
  },
  props: {
    current: {
      type: Object
    },
    isActive: {
      type: Boolean
    },
    isLast: {
      type: Boolean
    }
  }
}
</script>

<style scoped lang="scss">
$text-color: #dddddd;
$active-color: #1480e3;
$active-text-color: #fff;

.level_one_item {
  @include menuTextColor();

  .iconfont {
    font-size: 14px;
    margin-right: 12px;
  }

  height: 40px;
  width: 100%;
  flex-grow: 0;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.3s;
  padding-left: 16px;

  a {
    color: $text-color;
  }

  &.is-active,
  &:hover {
    background: $active-color;
    color: $active-text-color;

    a {
      color: $text-color;
    }
  }
}
</style>
